import { getProductLayoutsSchema } from '@messenger/types'
import type { GetLayoutsFromProductsNormalized } from '@messenger/types'
import { z } from 'zod'
import axios from '@/api/axios.config'

export const getLayoutsByProduct = async (
  productId: z.infer<typeof getProductLayoutsSchema>['productId'],
) => {
  return await axios.get<{ layouts: GetLayoutsFromProductsNormalized[] }>(
    `layouts?product_id=${productId}`,
  )
}

export const getLayoutById = async (
  layoutId: string,
  isM3: boolean = false,
) => {
  return await axios.get<GetLayoutsFromProductsNormalized>(
    `layouts/${layoutId}?isM3=${isM3}`,
  )
}
